import { FEEDBACK_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import feedbackTypes from '../../constants/feedbackTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_feedback_request = () => {
  return {
    type: feedbackTypes.get.request
  }
}

const get_feedback_success = (response) => {
  return {
    type: feedbackTypes.get.success,
    payload: response.data.feedback
  }
}

const get_feedback_failure = (messages) => {
  return {
    type: feedbackTypes.get.failure,
    payload: messages
  }
}

const get_feedback = (feedback_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_feedback_request())

    // Request
    axios.get(
      formatRoute(FEEDBACK_ROUTES.get, {id: feedback_id})
    ).then( response => {
      // success
      dispatch( get_feedback_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feedback."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_feedback_failure(errors))
    })
  }
}

const get_feedback_by_position = (skip=0, filters={}, sort='', order='') => {
  return function (dispatch) {
    // Before Request
    dispatch(get_feedback_request())

    // Request
    axios.get(
      FEEDBACK_ROUTES.get_feedback_by_position,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          skip: skip
        }
      }
    ).then( response => {
      // success
      dispatch( get_feedback_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feedback."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_feedback_failure(errors))
    })
  }
}


export {
  get_feedback,
  get_feedback_by_position
}



// WEBPACK FOOTER //
// ./src/js/actions/feedback/get.js